import React, { useState } from 'react'
import { TableCell, TableRow } from '@/components/ui/table'
import { Dialog, DialogDescription, DialogTrigger } from '@/components/ui/dialog'
import { StatusBadge } from '@/components'
import RewardsBadge from '@/components/rewards-badge'
import AccordionClose from '@/assets/icons/accordion-close'
import AccordionOpen from '@/assets/icons/accordion-open'
import ReportProblemDialog from '../../report-problem-dialog'
import Amount from '../../Amount'
import TransactionsTableSkeleton from '../../../home-page/transactions-table.skeleton'
import { format } from 'date-fns'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { convertUTCToET } from '@/utils/date-format-util'

const PostedTransactionsRaws = ({ data, page }) => {
  const navigate = useNavigate()

  const [expandedTx, setExpandedTx] = useState('')

  const toggleAccordion = txId => {
    const selectedTransaction = data.find(tx => tx.id === txId)
    if (
      selectedTransaction?.redemptionMethod === 'CASH' ||
      selectedTransaction.transactionType === 'Fee' ||
      selectedTransaction.transactionType === 'Interest' ||
      selectedTransaction.transactionType === 'Adjustments'
    )
      return
    if (txId === expandedTx) {
      setExpandedTx('non')
    } else {
      setExpandedTx(txId)
    }
  }

  //This function filtered the transactions method according to response data
  const filterTransactionsMethod = posDetails => {
    if (posDetails) {
      if (posDetails?.isCardHolderPresent === true && posDetails?.isCardPresent === true) {
        return 'In-Store'
      } else {
        return 'Online'
      }
    }
  }

  const renderTableRows = () => {
    const transactionsToRender = page === 'home' ? (data?.length > 5 ? data.slice(0, 5) : data) : data
    return transactionsToRender?.map((transaction, index) => {
      let accordionState = transaction?.id === expandedTx
      return (
        <React.Fragment key={transaction?.id + index}>
          <TableRow
            onClick={() => toggleAccordion(transaction?.id)}
            className={accordionState ? 'bg-[#FCFCFD] border-0' : ''}
            data-testid="transaction-table-row"
          >
            <TableCell className="font-normal text-sm text-neutral-700 hidden md:table-cell">
              <div className="flex items-center">
                {transaction?.redemptionMethod !== 'CASH' &&
                  !['Fee', 'Interest', 'Adjustments'].includes(transaction?.transactionType) &&
                  (accordionState ? <AccordionClose /> : <AccordionOpen />)}
                {!accordionState ? (
                  <span
                    className={`text-sm ${
                      transaction?.redemptionMethod !== 'CASH' &&
                      !['Fee', 'Interest', 'Adjustments'].includes(transaction?.transactionType)
                        ? 'ml-3'
                        : ''
                    }`}
                  >
                    {transaction?.postedDate && !isNaN(new Date(transaction.postedDate).getTime())
                      ? format(new Date(convertUTCToET(transaction.postedDate)), 'MMM dd, yyyy')
                      : '-'}
                  </span>
                ) : (
                  <TableCell className="font-semibold text-medium font-lg">
                    <div className=" bg-[#FCFCFD]">
                      <div className="mb-2 text-neutral-900 font-medium text-sm">Posted date</div>
                      <div className="text-neutral-700 font-normal text-sm">
                        {transaction?.postedDate
                          ? format(new Date(convertUTCToET(transaction.postedDate)), 'MMM dd, yyyy')
                          : '-'}
                      </div>
                    </div>
                  </TableCell>
                )}
              </div>
            </TableCell>
            <TableCell className="hidden md:table-cell">
              <div className="flex items-center">
                <StatusBadge status={'posted'} />
              </div>
            </TableCell>
            <TableCell className="hidden md:table-cell">
              <p className="text-sm font-medium text-neutral-900" data-testid="posted-transaction-description">
                {transaction?.bankName || transaction?.merchantName === 'Check Payment'
                  ? 'Payment - Thank You'
                  : transaction?.redemptionMethod
                    ? transaction.redemptionMethod === 'CASH'
                      ? 'Statement Credit'
                      : transaction.redemptionMethod
                    : transaction.transactionType === 'Fee'
                      ? 'Fee'
                      : transaction.transactionType === 'Interest'
                        ? 'Interest'
                        : transaction.transactionType === 'Adjustments'
                          ? 'Adjustment'
                          : transaction?.merchantName ||
                            transaction?.merchantDetails?.name ||
                            'No Merchant Information'}
              </p>
            </TableCell>
            <TableCell className="flex flex-row items-center w-[200px] max-[374px]:w-auto text-sm font-medium text-neutral-900 px-0 md:px-4 md:hidden">
              <div className="md:hidden mr-2">
                {transaction?.redemptionMethod !== 'CASH' &&
                  !['Fee', 'Interest', 'Adjustments'].includes(transaction?.transactionType) &&
                  (accordionState ? <AccordionClose /> : <AccordionOpen />)}
              </div>
              <div className="flex flex-col">
                <p className=" text-sm font-medium text-neutral-900">
                  {transaction?.bankName || transaction?.merchantName === 'Check Payment'
                    ? 'Payment - Thank You'
                    : transaction?.redemptionMethod
                      ? transaction.redemptionMethod === 'CASH'
                        ? 'Statement Credit'
                        : transaction.redemptionMethod
                      : transaction.transactionType === 'Fee'
                        ? 'Fee'
                        : transaction.transactionType === 'Interest'
                          ? 'Interest'
                          : transaction.transactionType === 'Adjustments'
                            ? 'Adjustment'
                            : transaction?.merchantName ||
                              transaction?.merchantDetails?.name ||
                              'No Merchant Information'}
                </p>
                <div className="text-neutral-700 font-normal text-sm">
                  {transaction?.postedDate
                    ? format(new Date(convertUTCToET(transaction.postedDate)), 'MMM dd, yyyy')
                    : '-'}
                </div>
              </div>
            </TableCell>
            <TableCell className={`font-bold text-nowrap text-sm text-neutral-700 hidden md:table-cell`}>
              {transaction?.bankName || transaction?.redemptionMethod ? null : (
                <div className="flex items-center">
                  {transaction?.rewardClass === 'Default' ? null : <RewardsBadge rule={transaction?.rewardClass} />}
                </div>
              )}
            </TableCell>
            <TableCell>
              <div className="flex flex-col justify-center md:items-start items-end">
                <Amount
                  amount={transaction?.amount.value}
                  sign={transaction?.sign === 'NEGATIVE' ? null : transaction?.sign}
                  customColor={
                    transaction?.bankName ||
                    transaction?.redemptionMethod ||
                    ((transaction?.transactionType === 'InterFinancialAccountTransfer' ||
                      transaction?.transactionType === 'Adjustments') &&
                      transaction.sign === 'POSITIVE')
                      ? 'text-success-600'
                      : 'text-neutral-700'
                  }
                />
                <div className="md:hidden">
                  <StatusBadge status={'posted'} />
                </div>
              </div>
            </TableCell>
          </TableRow>
          {accordionState && (
            <>
              <TableRow className="border-0 bg-[#FCFCFD] md:border-b-[1px] md:border-b-gray-200">
                <TableCell className="font-semibold text-medium font-lg md:pl-10 hidden md:table-cell">
                  <div className="mb-2 text-neutral-900 font-medium text-medium text-sm -mt-6">Transaction date</div>
                  <div className="text-neutral-700 font-normal text-sm">
                    {transaction?.transactionDate && transaction?.transactionDate !== ''
                      ? format(new Date(convertUTCToET(transaction?.transactionDate)), 'MMM dd, yyyy')
                      : '-'}
                  </div>
                </TableCell>
                <TableCell className="hidden md:table-cell"></TableCell>
                <TableCell className="font-semibold text-medium font-lg hidden md:table-cell pr-0">
                  <div className="mb-2 text-sm font-medium text-neutral-900 -mt-6">
                    {transaction?.bankName || transaction?.merchantName === 'Check Payment'
                      ? 'Paid From'
                      : 'Also known as'}
                  </div>
                  <div className="text-neutral-700 font-normal text-sm pr-8">
                    {transaction?.bankName
                      ? `${transaction?.bankName.name} •••• ${transaction?.bankName?.externalBankAccountDetails?.last4}`
                      : transaction?.merchantDetails?.name || transaction?.merchantName || 'No Merchant Information'}
                  </div>
                </TableCell>
                <TableCell className="font-semibold text-medium font-lg hidden md:table-cell">
                  {transaction?.bankName || transaction?.merchantName === 'Check Payment' ? null : (
                    <>
                      <div className="mb-2 text-neutral-900 font-medium text-medium text-sm -mt-6">Method</div>
                      <div className="text-neutral-700 font-normal text-sm">
                        {transaction?.posDetails ? filterTransactionsMethod(transaction?.posDetails) : '-'}
                      </div>
                    </>
                  )}
                </TableCell>
                <TableCell className="hidden justify-items-start text-left justify-start md:table-cell pr-0">
                  {transaction?.bankName ? (
                    <p
                      className="cursor-pointer font-semibold text-brand-500 text-sm items-start"
                      onClick={() => navigate('/payments/payment-history')}
                    >
                      Payment History
                    </p>
                  ) : (
                    <Dialog>
                      <DialogTrigger>
                        <DialogDescription className="cursor-pointer font-semibold text-brand-500 text-sm">
                          Report a problem
                        </DialogDescription>
                      </DialogTrigger>
                      <ReportProblemDialog transaction={transaction} />
                    </Dialog>
                  )}
                </TableCell>
              </TableRow>
              {!transaction?.bankName && transaction?.merchantName != 'Check Payment' ? (
                <TableRow className="border-0 bg-[#FCFCFD] md:hidden">
                  <TableCell colSpan={2} className="p-0">
                    <div className="grid grid-cols-2 gap-4 mt-2">
                      <div className="flex flex-col text-left items-start">
                        <div className="mb-2 text-sm font-medium text-neutral-900 ">Also known as</div>
                        <div className="text-neutral-700  font-normal text-sm">
                          {transaction?.merchantDetails?.name || transaction?.merchantName || 'No Merchant Information'}
                        </div>
                        <div className="mb-2 mt-4 text-neutral-900 font-medium text-sm">Transaction date</div>
                        <div className="text-neutral-700  font-normal text-sm">
                          {transaction?.transactionDate && transaction?.transactionDate !== ''
                            ? format(new Date(convertUTCToET(transaction?.transactionDate)), 'MMM dd, yyyy')
                            : '-'}
                        </div>
                      </div>
                      <div className="flex flex-col text-right items-end pr-4">
                        <div className="text-neutral-700  font-normal text-sm">
                          {transaction?.rewardClass === 'Default' ? null : (
                            <RewardsBadge rule={transaction?.rewardClass} />
                          )}
                        </div>
                        <br />
                        <div
                          className={`mb-2 ${transaction?.rewardClass != 'Default' ? 'mt-5' : 'mt-11'} text-neutral-900 font-medium text-sm`}
                        >
                          Method
                        </div>
                        <div className="text-neutral-700  font-normal text-sm">
                          {transaction?.merchantName === 'Check Payment'
                            ? null
                            : transaction?.posDetails
                              ? filterTransactionsMethod(transaction?.posDetails)
                              : '-'}
                        </div>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              ) : transaction?.merchantName === 'Check Payment' ? (
                <TableRow className="border-0 bg-[#FCFCFD] md:hidden">
                  <TableCell colSpan={2} className="p-0">
                    <div className="flex justify-between mt-2">
                      <div className="flex flex-col text-left items-start w-[180px]">
                        <div className="mb-2 text-sm font-medium text-neutral-900 ">Paid From</div>
                        <div className="flex items-center text-neutral-700  font-normal text-sm">
                          {transaction?.merchantName || transaction?.merchantDetails?.name || 'No Merchant Information'}
                        </div>
                      </div>
                      <div className="flex flex-col text-left items-start w-[124px] pr-3">
                        <div className="mb-2 text-sm font-medium text-neutral-900  ">Transaction date</div>
                        <div className="text-neutral-700  font-normal text-sm text-left">
                          {transaction?.transactionDate && transaction?.transactionDate !== ''
                            ? format(new Date(convertUTCToET(transaction?.transactionDate)), 'MMM dd, yyyy')
                            : '-'}
                        </div>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow className="border-0 bg-[#FCFCFD] md:hidden">
                  <TableCell colSpan={2} className="p-0">
                    <div className="flex justify-between mt-2">
                      <div className="flex flex-col text-left items-start w-[180px]">
                        <div className="mb-2 text-sm font-medium text-neutral-900 ">Paid From</div>
                        <div className="flex items-center text-neutral-700  font-normal text-sm">
                          {transaction?.bankName?.name} •••• {transaction?.bankName?.externalBankAccountDetails?.last4}
                        </div>
                      </div>
                      <div className="flex flex-col text-left items-start w-[124px] pr-3">
                        <div className="mb-2 text-sm font-medium text-neutral-900  ">Transaction date</div>
                        <div className="text-neutral-700  font-normal text-sm text-left">
                          {transaction?.transactionDate && transaction?.transactionDate !== ''
                            ? format(new Date(convertUTCToET(transaction?.transactionDate)), 'MMM dd, yyyy')
                            : '-'}
                        </div>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              )}
              <TableRow className="border-b-[1px] bg-[#FCFCFD] md:hidden ">
                <TableCell
                  colSpan={3}
                  className="font-semibold font-lg text-brand-600 text-sm text-center md:pt-0 pt-8"
                >
                  <div className="md:hidden bg-[#FCFCFD] flex justify-center items-center">
                    {transaction?.bankName ? (
                      <p
                        className="cursor-pointer font-semibold text-brand-500 text-sm md:ml-[-100px]"
                        onClick={() => navigate('/payments/payment-history')}
                      >
                        Payment History
                      </p>
                    ) : (
                      <Dialog>
                        <DialogTrigger>
                          <p className="cursor-pointer font-semibold text-brand-500 text-sm">Report a problem</p>
                        </DialogTrigger>
                        <ReportProblemDialog transaction={transaction} />
                      </Dialog>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            </>
          )}
          {/* Added this to add a last border line in the table */}
          <TableRow></TableRow>
        </React.Fragment>
      )
    })
  }

  return !data ? <TransactionsTableSkeleton /> : data?.length > 0 && renderTableRows()
}

export default PostedTransactionsRaws

PostedTransactionsRaws.propTypes = {
  data: PropTypes.array,
  page: PropTypes.string,
}
